import React from 'react';
import Lottie from 'lottie-react';

const LottieAnimation = ({ animationData, className, loop = true, autoplay = true }) => {
  return (
    <Lottie
      animationData={animationData}
      loop={loop}
      autoplay={autoplay}
      className={className}
    />
  );
};

export default LottieAnimation; 